import { Text } from '@fluentui/react-components';
import { observer } from 'mobx-react-lite';
import React from 'react';
import './PageTitle.scss';

interface PageTitleProps {
  title: string;
  subtitle?: string;
  textHeaderTag?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
  titleSize?: 100 | 200 | 300 | 400 | 500 | 600 | 700 | 800 | 900 | 1000;
}

const PageTitleImpl: React.FC<PageTitleProps> = props => {
  const {
    title,
    subtitle,
    textHeaderTag = 'h1',
    titleSize = 800,
  } = props;

  return (
    <div
      className='page-title'
    >
      <Text
        size={400}
        weight='semibold'
      >
        {subtitle}
      </Text>
      <Text
        as={textHeaderTag}
        size={titleSize}
        weight='semibold'
        block
      >
        {title}
      </Text>
    </div>
  );
}

export const PageTitle = observer(PageTitleImpl);
